export default __webpack_public_path__ + "static/media/home.d74eb357.svg";